export const ListQueryKey = 'diceRecords';
export const DetailQueryKey = 'diceRecord';

export const Urls = {
  selectUrl: '/diceRecord/list',
  updateUrl: '/diceRecord/update',
  deleteUrl: '/diceRecord/delete',
  createUrl: '/diceRecord/create',
  detailUrl: '/diceRecord/detail',
};
